import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/bubble-chart/pages/CalculatorPage";

export const Route = createFileRoute("/bubble-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/bubble-chart",
      title: m.bubble_meta_title(),
      description: m.bubble_meta_description(),
      toolName: m.bubble_tool_name(),
      faqs: [
        { q: m.bubble_faq_q1(), a: m.bubble_faq_a1() },
        { q: m.bubble_faq_q2(), a: m.bubble_faq_a2() },
        { q: m.bubble_faq_q3(), a: m.bubble_faq_a3() },
        { q: m.bubble_faq_q4(), a: m.bubble_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
